export default {
  type: 'tab',
  active: '0',
  tabType: 'border-card',
  onTabClick: (vm, tab, { model }) => {
    const { uiApp } = vm.mForm.editor.editorCore;
    const status = tab.name;
    const comp = uiApp.getComponent(model.name);
    comp.disabled = status === 'disabled';
  },
  items: [{
    title: '按钮默认状态',
    labelWidth: '100px',
    items: [{
      type: 'component',
      id: 'background',
    }, {
      name: 'style',
      items: [{
        text: '文字颜色',
        name: 'color',
        inputType: 'colorPicker',
      }],
    }],
  }, {
    title: '按钮置灰状态',
    status: 'disabled',
    labelWidth: '100px',
    items: [{
      type: 'component',
      id: 'disabledBackground',
    }, {
      name: 'disabledStyle',
      items: [{
        text: '文字颜色',
        name: 'color',
        inputType: 'colorPicker',
      }],
    }],
  }],
};
